// Mock data for Anlar Oto Dizayn clone

export const services = [
  {
    id: 1,
    title: 'DERİ KOLTUK DÖŞEME',
    description: 'Deri ve kumaş seçenekleriyle koltuklar sıfır görünümüne kavuşur. Her dikiş ustalarımızın elinden geçer.',
    tags: ['Deri', 'Kumaş', 'El Dikişi'],
    image: 'https://images.unsplash.com/photo-1601673632676-12f89e430aa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsZWF0aGVyJTIwc2VhdHN8ZW58MHx8fHwxNzc4Nzg5NDM0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    title: 'KOLTUK TAMİRİ',
    description: 'Yırtık, solan veya hasar görmüş koltuklar orijinal görünümüyle geri döner.',
    tags: ['Yırtık Onarım', 'Renk Yenileme'],
    image: 'https://images.unsplash.com/photo-1563986642669-49162177a0bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwc2VhdHN8ZW58MHx8fHwxNzc4Nzg5NDM0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    title: 'SÜNGER DEĞİŞİMİ',
    description: 'Çökmüş ve sertleşmiş süngerler yenilenerek araç konforunu yeniden kazandırır.',
    tags: ['Yüksek Yoğunluklu Sünger'],
    image: 'https://images.unsplash.com/photo-1667893530449-e58102223524?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsZWF0aGVyJTIwc2VhdHN8ZW58MHx8fHwxNzc4Nzg5NDM0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    title: 'EMNİYET KEMERİ DEĞİŞİMİ',
    description: 'Solmuş ve hasar görmüş emniyet kemerleri güvenlik standartlarında yenilenir.',
    tags: ['OEM Uyumlu', 'Güvenli Teslim'],
    image: 'https://images.unsplash.com/photo-1629820408206-e9fc918abf63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 5,
    title: 'TAVAN DÖŞEME',
    description: 'Sararmış, lekelenmiş veya sarkık tavanlar prima kumaşla tamamen yenilenir.',
    tags: ['Prima Kumaş', 'Alcantara'],
    image: 'https://images.unsplash.com/photo-1432462770865-65b70566d673?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 6,
    title: 'DİREKSİYON KAPLAMA',
    description: 'Alcantara, deri ve kumaş seçenekleriyle direksiyon kaplama. Sürüş deneyimini yeniden tanımlayın.',
    tags: ['Alcantara', 'Deri', 'Kumaş'],
    image: 'https://images.unsplash.com/photo-1610647752706-3bb12232b3ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxzdGVlcmluZyUyMHdoZWVsfGVufDB8fHx8MTc3ODc4OTQzNHww&ixlib=rb-4.1.0&q=85',
  },
];

export const beforeAfterItems = [
  {
    id: 1,
    label: 'Koltuk Döşeme',
    sublabel: 'Deri & Kumaş Koltuk Yenileme',
    chip: 'Premium Deri',
    before: 'https://images.pexels.com/photos/18262241/pexels-photo-18262241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    after: 'https://images.unsplash.com/photo-1599912027667-755b68b4dd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    label: 'Tavan Döşeme',
    sublabel: 'Prima Kumaş Tavan Yenileme',
    chip: 'Alcantara',
    before: 'https://images.pexels.com/photos/16716122/pexels-photo-16716122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    after: 'https://images.unsplash.com/photo-1432462770865-65b70566d673?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    label: 'Direksiyon Kaplama',
    sublabel: 'Alcantara Direksiyon Kaplama',
    chip: 'El İşçiliği',
    before: 'https://images.unsplash.com/photo-1471174617910-3e9c04f58ff5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxzdGVlcmluZyUyMHdoZWVsfGVufDB8fHx8MTc3ODc4OTQzNHww&ixlib=rb-4.1.0&q=85',
    after: 'https://images.unsplash.com/photo-1612805144400-88c7821bf36f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxzdGVlcmluZyUyMHdoZWVsfGVufDB8fHx8MTc3ODc4OTQzNHww&ixlib=rb-4.1.0&q=85',
  },
];

export const processSteps = [
  {
    icon: 'Calendar',
    number: '01',
    title: 'Randevu',
    description: 'Aracınızı atölyemizde ya da WhatsApp üzerinden fotoğraflarla değerlendiriyoruz. Bütçe ve beklentilerinizi dinliyoruz.',
    highlight: 'Ücretsiz ön değerlendirme',
  },
  {
    icon: 'Palette',
    number: '02',
    title: 'Malzeme Seçimi',
    description: 'Deri, kumaş ve renk seçenekleri arasından birlikte karar veriyoruz. Yüzlerce seçenek, tek doğru tercih.',
    highlight: 'Geniş malzeme yelpazesi',
  },
  {
    icon: 'Scissors',
    number: '03',
    title: 'Ustanın Elinde',
    description: 'Her dikiş, her kaplama titizlikle uygulanır. Hiçbir detay gözden kaçmaz — deneyimli ekibimiz fark yaratır.',
    highlight: 'Deneyimli usta ekibi',
  },
  {
    icon: 'Trophy',
    number: '04',
    title: 'Teslim',
    description: 'Aracınızı garantili ve bakım önerileriyle teslim ediyoruz. İşimizin her zaman arkasındayız.',
    highlight: 'Garantili teslim',
  },
];

export const features = [
  { icon: 'MapPin', text: 'Yerinde Değerlendirme' },
  { icon: 'Shield', text: 'Garantili İşçilik' },
  { icon: 'CheckCircle2', text: 'Kaliteli Malzeme' },
  { icon: 'MessageSquare', text: 'Hızlı Yanıt' },
];

export const brands = ['BMW', 'MB', 'AUDI', 'TOYOTA', 'VW', 'RENAULT', 'FORD', 'FIAT'];

export const testimonials = [
  {
    id: 1,
    name: 'Mehmet K.',
    car: 'Volkswagen Passat Sahibi',
    rating: 5,
    quote: 'Koltukların üzerindeki dikişler mükemmel. Arabam yıllarca kullanılmış olmasına rağmen şimdi sıfır gibi görünüyor. Anlar Oto\'yu gönül rahatlığıyla tavsiye ederim.',
  },
  {
    id: 2,
    name: 'Ayşe D.',
    car: 'Audi A4 Sahibi',
    rating: 5,
    quote: 'Tavan döşememi yaptırdım, kullandıkları prima kumaş gerçekten çok kaliteli. İşçilik kusursuzdu, zamanında teslim aldım. Çok memnunum.',
  },
  {
    id: 3,
    name: 'Kemal T.',
    car: 'BMW 3 Serisi Sahibi',
    rating: 5,
    quote: 'Direksiyonumu alcantara ile kapladılar, görünümü harika oldu. Emniyet kemeri değişimini de yaptırdım, her şey mükemmel. Teşekkürler!',
  },
  {
    id: 4,
    name: 'Fatma S.',
    car: 'Mercedes C Serisi Sahibi',
    rating: 5,
    quote: 'Koltuk sünger değişimi yapıldı, aracın konforu inanılmaz değişti. Profesyonel ekip, kaliteli malzeme. Kesinlikle tavsiye ederim.',
  },
  {
    id: 5,
    name: 'Hasan Y.',
    car: 'Toyota Corolla Sahibi',
    rating: 5,
    quote: 'Koltuk tamiri için gittim, yırtıkları öyle güzel onardılar ki yeri belli olmuyor. Fiyat-performans olarak çok başarılılar.',
  },
];

export const faqs = [
  {
    q: 'Hangi döşeme malzemelerini kullanıyorsunuz?',
    a: 'Deri, kumaş, alcantara ve prima kumaş seçenekleri sunuyoruz. Müşterimizin bütçesi ve tercihi doğrultusunda en uygun malzemeyi birlikte seçiyoruz.',
  },
  {
    q: 'İşçilik garantisi veriyor musunuz?',
    a: 'Evet, tüm işçiliklerimiz garanti kapsamındadır. Kullanılan malzeme ve uygulama tipine göre garanti süresi değişebilmektedir.',
  },
  {
    q: 'Aracım ne kadar sürede teslim edilir?',
    a: 'Yapılacak işin kapsamına bağlı olarak süre değişir. Genelde tek koltuk yenilemesi 1-2 gün, komple iç döşeme 4-7 gün arasında tamamlanır.',
  },
  {
    q: 'Orijinal görünümü koruyabilir miyim?',
    a: 'Kesinlikle. Talebiniz doğrultusunda OEM uyumlu malzemelerle aracınızın orijinal görünümünü birebir koruyabiliyoruz.',
  },
  {
    q: 'Emniyet kemeri değişimi zorunlu mu?',
    a: 'Solmuş, kesilmiş veya hasar görmüş emniyet kemerleri güvenlik açısından mutlaka değiştirilmelidir. OEM uyumlu kemerlerle güvenli teslim sağlıyoruz.',
  },
  {
    q: 'Fiyat teklifi nasıl alırım?',
    a: 'WhatsApp üzerinden aracınızın fotoğraflarını ve isteklerinizi bize iletmeniz yeterli. Ortalama 15 dakika içinde ücretsiz teklifimizi sunuyoruz.',
  },
  {
    q: 'Hangi araç markalarına hizmet veriyorsunuz?',
    a: 'Tüm marka ve model araçlara hizmet veriyoruz. BMW, Mercedes, Audi, Volkswagen, Toyota, Ford, Renault, Fiat ve daha pek çok marka için döşeme hizmetlerimiz mevcuttur.',
  },
  {
    q: 'Döşeme sonrası nasıl bakım yapmalıyım?',
    a: 'Teslimat sırasında size detaylı bakım önerileri sunuyoruz. Genel olarak nemli yumuşak bir bezle silmek ve uygun bakım ürünleri kullanmak önerilir.',
  },
];

export const stats = [
  { value: '6K+', label: 'Takipçi' },
  { value: '5★', label: 'Müşteri Memnuniyeti' },
  { value: '284', label: 'Gönderi' },
];

export const heroImage = 'https://images.unsplash.com/photo-1599912027667-755b68b4dd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85';
export const transformBg = 'https://images.unsplash.com/photo-1627454819213-4b261f3c3b90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg3ODk0MzR8MA&ixlib=rb-4.1.0&q=85';
